export default __webpack_public_path__ + "static/media/classroom-blue.ddf1735c.svg";